export default __webpack_public_path__ + "static/media/1312.69cca0c5.png";